import axios from '../../apis/apicidtech';
import { types } from '../../types/types';
import { getToken } from '../../utils/tokencidtechapi';
import { dispatchpending, dispatchresponse, dispatchresponseerror } from '../utils/dispatches';

export const pesquisa = (filtro = {}) => {
    
    return async dispatch => {

        dispatchpending(dispatch);

        try{
            const response = await axios.get('credenciamento/usuarios/cargos/pesquisa',
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`
                    },
                    params:{
                        ...filtro
                    }
                }
            );
            
            dispatchresponse(dispatch,response.data,types.CREDENCIAMENTO.CARGOS_PESQUISA);

        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}